<template>
  <component-wrapper>
    <grid-container-fi>
      <div class="fi-col-span-12 fi-col-start-1 lg:fi-col-span-7 lg:fi-col-start-2">
        <single-line-text-field-fi
          field-name="subheadline"
          class="link-list-fi__subheadline"
        />
        <h3
          v-if="fields.headline?.value || isEditMode || inlineEditMode"
          class="link-list-fi__headline"
        >
          <single-line-text-field-fi field-name="headline" />
        </h3>
      </div>

      <div
        v-if="fields.linkListElements?.length"
        class="fi-col-span-12 fi-col-start-1 lg:fi-col-span-10 lg:fi-col-start-2"
      >
        <ul class="link-list-fi__list">
          <multi-data-source-provider-fi field-name="linkListElements">
            <li>
              <link-field-fi
                field-name="link"
                class="link-list-fi__link fi-text-24"
              >
                <template #default="{ linkField }">
                  <span class="link-list-fi__link-span">{{ linkField?.value?.text }}</span>
                  <span class="link-list-fi__link-icon"><arrow-icon /></span>
                </template>
              </link-field-fi>
            </li>
          </multi-data-source-provider-fi>
        </ul>
      </div>
      <div
        v-if="isEditMode && !fields.linkListElements.length"
        class="link-list-fi__xpe__no-elements fi-col-span-10 fi-col-start-2 fi-mt-24"
      >
        <icon-fi icon="info" /> no link list elements !
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import {
  ArrowIcon,
  IconFi,
  LinkFieldFi,
  MultiDataSourceProviderFi,
  SingleLineTextFieldFi,
} from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFields } from '@/composables/fields';
import { useInlineEdit } from '@/composables/inlineEdit';

defineOptions({
  name: 'LinkListFi',
});

const fields = useFields('LinkListFiFields');

const { inlineEditMode } = useInlineEdit();
</script>

<style src="./link-list-fi-unscoped" />
